import { twMerge } from 'tailwind-merge';

import type { QuickAddContainerProps } from './types';

import { SectionHeading } from '../headers';

const QuickAddContainerBase = ({
  ref,
  sectionTitle,
  rightSlot,
  icon,
  fixedHeight = false,
  children,
  className,
}: QuickAddContainerProps & {
  ref?: React.RefObject<HTMLDivElement | null>;
}) => (
  <>
    {sectionTitle && <SectionHeading icon={icon} text={sectionTitle} rightSlot={rightSlot} />}
    <div
      ref={ref}
      className={twMerge(
        'mr-0',
        sectionTitle && 'mt-6',
        fixedHeight && 'max-h-60 overflow-x-hidden overflow-y-auto',
        className
      )}
    >
      {children}
    </div>
  </>
);

export const QuickAddContainer = QuickAddContainerBase;
